import {
  IAboutYouFormModel,
  IAboutYouYPFormModel,
  CurrentMemberBlockPropsType,
} from "./AboutYouFormModel";
import { IEligibilityFormModel } from "./EligibilityFormModel";
import { IReviewFormModel } from "./ReviewFormModel";

export enum FormStep {
  Eligibility = "eligibility",
  AboutYou = "about-you",
  AboutYouMPCurrentMember = "about-you-mp-current-member",
  AboutYouYP = "about-you-yp",
  Agencies = "agencies",
  Review = "review",
}

export interface IFormModel {
  [FormStep.Eligibility]: IEligibilityFormModel;
  [FormStep.AboutYou]: IAboutYouFormModel;
  [FormStep.AboutYouMPCurrentMember]: CurrentMemberBlockPropsType;
  [FormStep.AboutYouYP]: IAboutYouYPFormModel;
  [FormStep.Review]: IReviewFormModel;
}

export interface IUpdateFormValues {
  formStep: FormStep;
  formValues:
    | IEligibilityFormModel
    | IAboutYouFormModel
    | IAboutYouYPFormModel
    | IReviewFormModel
    | undefined;
}
